import BaseModel from './base-model';
/**
 {
  "@id": 1000934,
  "@REL_ATTR": 1000934
}
*/
export default class ResourceFamily extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
